export class Creneau {
    jour: number;
    regulier: boolean;
    debut: string;
    fin: string;
    min: string;
    max: string;
    occasionnel: boolean;

    constructor(jour?: number, debut?: string, fin?: string, min?: string, max?: string) {
        if (jour) this.jour = jour;
        if (debut) this.debut = debut;
        if (fin) this.fin = fin;
        if (min) this.min = min;
        if (max) this.max = max;
    }
}

export class Jours {
    static LUNDI = 2;
    static MARDI = 3;
    static MERCREDI = 4;
    static JEUDI = 5;
    static VENDREDI = 6;
    static SAMEDI = 7;
    static DIMANCHE = 1;

    static getLabel(n: number): string {
        switch (n) {
            case this.LUNDI:
                return 'Lundi';
                break;        
            case this.MARDI:
                return 'Mardi';
                break;        
            case this.MERCREDI:
                return 'Mercredi';
                break;        
            case this.JEUDI:
                return 'Jeudi';
                break;        
            case this.VENDREDI:
                return 'Vendredi';
                break;        
            case this.SAMEDI:
                return 'Samedi';
                break;        
            case this.DIMANCHE:
                return 'Dimanche';
                break;        
            default:
                return 'Inconnu';
                break;
        }
    }
}